const IH_EVENT_TYPE_CODES = ["RPPM", "TFCP", "TXLS"];
const IH_INVESTMENT_TYPE_CODES = ["ARPP", "TFCP", "TAXL"];

export function isValidIncomeHistoryEvent(event) {
    return IH_EVENT_TYPE_CODES.includes(event.trevTtypCode);
}

export function isValidIncomeHistoryInvestment(investment) {
    return IH_INVESTMENT_TYPE_CODES.includes(investment.itrnTtypCode);
}
